<template>
  <div class="header">
    <b-navbar class="header">
      <div class="container col-12">
        <router-link class="lien_image" :to="{name:'Home'}">
          <img alt="logo" src="../assets/logo-neobus.jpg" width="350px">
        </router-link>
      </div>
    </b-navbar>
    <div class="container col-12">
      <a href="https://ccov.fr/" class="lien_image">
        <img class="center_horizonthal" alt="logo" src="../assets/logo_ccov.png" width="250px">
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Header'
  }
</script>

<style lang="scss">
@import "../sass/app";

.header {
  .lien_image {
    margin: auto;

  }

  .center_horizonthal {
    display: block;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue